export class ObjectCopyHelper {

    private static isObject(obj) {
        const type = typeof obj;
        return type === 'function' || type === 'object' && !!obj;
    };
    public static iterationCopy(src) {        
        let target = {};
        for (let prop in src) {
            if (src.hasOwnProperty(prop)) {
                // if the value is a nested object, recursively copy all it's properties
                if (this.isObject(src[prop])) {
                    target[prop] = this.iterationCopy(src[prop]);
                } else {
                    target[prop] = src[prop];
                }
            }
        }
        return target;
    }
}